export default __webpack_public_path__ + "static/media/social.75851ba9.svg";